module.exports = __webpack_public_path__ + "static/media/no-comments-icon.3a2e6c61.svg";